import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { US_STATES } from '../locations.constants';
export var MSCAN_LOCATIONS = [].concat(_toConsumableArray(US_STATES), [{
  name: 'Southern California',
  code: 'SA'
}, {
  name: 'San Diego',
  code: 'SI'
}]);